/* app/js/src/components/clipping-studio/left-sidebar/clipping-studio-left-sidebar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.left-sidebar {
  display: flex;
  height: 100%;
  flex-shrink: 0;
  z-index: 30;
}
.icon-strip {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: rgb(255, 255, 255);
  border-right: 1px solid #e2e8f1;
  flex-shrink: 0;
}
.icon-strip .close-row {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  border-bottom: 1px solid #f5f5f5;
}
.icon-strip .close-btn {
  padding: 0.5rem;
  color: #727d8b;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.icon-strip .close-btn:hover {
  background: #f5f5f5;
}
.icon-strip .close-btn .chevrons-left {
  display: block;
}
.icon-strip .tool-btn {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  padding: 0 8px;
  border: none;
  background: rgb(255, 255, 255);
  color: #727d8b;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  text-transform: capitalize;
  line-height: 15px;
}
.icon-strip .tool-btn:hover {
  background: #f5f5f5;
}
.icon-strip .tool-btn.active {
  background: #e2e8f1;
  color: #232f3a;
}
.icon-strip .tool-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-strip .icon-svg {
  width: 24px;
  height: 24px;
  display: block;
}
.icon-strip .icon-svg.icon-svg-20 {
  width: 20px;
  height: 20px;
}
.icon-strip .transcript-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
.icon-strip .transcript-icon .icon-svg {
  position: absolute;
  inset: 8.33%;
}
.icon-strip .transcript-icon .cc-text {
  position: absolute;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  line-height: 15px;
  inset: 18.75%;
}
.icon-strip .tool-label {
  line-height: 15px;
}
.panel-container {
  width: 320px;
  min-width: 320px;
  height: 100%;
  background: rgb(255, 255, 255);
  border-right: 1px solid #e2e8f1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panel-container--overflow-visible {
  overflow: visible;
}
.panel-container evrideo-clipping-studio-find-clip-panel,
.panel-container evrideo-clipping-studio-media-panel,
.panel-container evrideo-clipping-studio-transcript-subtitles-panel,
.panel-container evrideo-clipping-studio-graphics-panel,
.panel-container evrideo-clipping-studio-text-panel {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.panel-container evrideo-clipping-studio-transcript-subtitles-panel {
  min-height: 0;
}
/*# sourceMappingURL=clipping-studio-left-sidebar.component.css.map */
